"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const helpers_1 = require("../helpers");
class PromotionManager {
    clicked({ pageTitle, pageSection, promotionTitle, promotionUrl, promotionPlacement, caseCategory, caseSubCategory, employmentType, }) {
        window.dataLayer.push({
            event: 'trackPromotion',
            promotionsidetitel: (0, helpers_1.toLowerOrEmpty)(pageTitle),
            promotionsidesektion: (0, helpers_1.toLowerOrEmpty)(pageSection),
            promotionindhold: (0, helpers_1.toLowerOrEmpty)(promotionTitle),
            promotiondestination: (0, helpers_1.toLowerAndStripHttp)(promotionUrl),
            promotionplacering: promotionPlacement || 0,
            sagsemne: (0, helpers_1.toLowerOrEmpty)(caseCategory),
            sagsunderemne: (0, helpers_1.toLowerOrEmpty)(caseSubCategory),
            sagsbeskæftigelsestype: (0, helpers_1.toLowerOrEmpty)(employmentType),
        });
    }
}
exports.default = PromotionManager;
